import { ApiClient } from './types';
import { AdminApiClient } from './types/admin-api-types';
import { StorageApiClient } from './types/storage-api-types';
import { supabaseClient } from './supabase-client';
import { supabaseAdminClient } from './supabase/admin-api-client';
import { supabaseStorageClient } from './supabase/storage-api-client';

// Backend types - add new backends here when implementing them
type BackendType = 'supabase' | 'custom' | 'third-party';

// Keep the active backend clients as module variables
let activeClient: ApiClient = supabaseClient;
let activeAdminClient: AdminApiClient = supabaseAdminClient;
let activeStorageClient: StorageApiClient = supabaseStorageClient;

/**
 * API factory to easily switch between different backend implementations
 */
export const ApiFactory = {
  /**
   * Get the current API client for public-facing features
   */
  getClient(): ApiClient {
    return activeClient;
  },
  
  /**
   * Get the current admin API client for admin panel
   */
  getAdminClient(): AdminApiClient {
    return activeAdminClient;
  },
  
  /**
   * Get the current storage API client
   */
  getStorageClient(): StorageApiClient {
    return activeStorageClient;
  },
  
  /**
   * Switch to a different backend implementation
   */
  setBackend(backend: BackendType): void {
    switch (backend) {
      case 'supabase':
        activeClient = supabaseClient;
        activeAdminClient = supabaseAdminClient;
        activeStorageClient = supabaseStorageClient;
        break;
      case 'custom':
        // Replace this with custom API clients when implemented
        console.warn('Custom API clients not yet implemented, using Supabase fallback');
        activeClient = supabaseClient;
        activeAdminClient = supabaseAdminClient;
        activeStorageClient = supabaseStorageClient;
        break;
      case 'third-party':
        // Replace this with third-party API clients when implemented  
        console.warn('Third-party API clients not yet implemented, using Supabase fallback');
        activeClient = supabaseClient;
        activeAdminClient = supabaseAdminClient;
        activeStorageClient = supabaseStorageClient;
        break;
      default:
        console.warn(`Unknown backend type: ${backend}, using Supabase fallback`);
        activeClient = supabaseClient;
        activeAdminClient = supabaseAdminClient;
        activeStorageClient = supabaseStorageClient;
    }
    console.log(`Active backend set to: ${backend}`);
  }
};
